/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportsCogsPurchasesService
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.cogs')
.factory('ReportsCogsPurchasesService', function() {

  /**
   * Take the combined results array and return the results for either a single category, or for all categories combined
   */
  var parseResults = function(allResults, categoryIds) {
    var reportResults = [];
    allResults.forEach(function(item) {
      if (categoryIds.length === 0) {
        reportResults.push({
          startTime: item.startTime,
          salesEx: item.salesEx,
          stockOrdered: item.stockOrdered,
          stockReceived: item.stockReceived,
          stockPerc: item.salesEx == 0 ? 0 : item.stockReceived / item.salesEx * 100
        });
      } else {
        reportResults.push(item.categories
          .filter(function(c) { return categoryIds.includes(c.posItemCategoryIdentifier); })
          .reduce(function(acc, c) {
            acc.salesEx += c.salesEx;
            acc.stockOrdered += c.stockOrdered;
            acc.stockReceived += c.stockReceived;
            return acc;
          }, {
            startTime: item.startTime,
            salesEx: 0,
            stockOrdered: 0,
            stockReceived: 0,
            get stockPerc() {
              return this.salesEx == 0 ? 0 : this.stockReceived / this.salesEx * 100;
            }
          }));
      }
    });

    return reportResults;
  };

  return {
    parseResults: parseResults
  };
});
